import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {formItemLayout} from "../utils/style";
import {bindActionCreators} from "redux";
import {addReturnReason} from "./actions";
import {getDescriptionFromError} from "../utils/errors";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddDiscountReasonForm extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    // state
    dispensaryId: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    // dispatch
    addReturnReason: PropTypes.func.isRequired
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const {addReturnReason, dispensaryId, form} = this.props;
    form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await addReturnReason({...values, dispensaryId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    return (
      <Card title="Add Return Reason">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input autoFocus/>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Return Reason
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const AddDiscountReasonPage = Form.create()(AddDiscountReasonForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  loading: state.returnReason.addingReturnReason,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  addReturnReason,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(AddDiscountReasonPage);



// WEBPACK FOOTER //
// ./src/ReturnReason/AddReturnReasonPage.js